import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AdminAuthService } from '../../admin/services/admin-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const adminAuthService = inject(AdminAuthService);
  const router = inject(Router);

  // Only add auth header to API requests (not external URLs)
  if (req.url.includes('/api/')) {
    const token = adminAuthService.getToken();
    
    if (token) {
      // Clone the request and add the Authorization header
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            // Token expired or invalid, clear auth state and redirect to login
            adminAuthService.logout();
            router.navigate(['/admin/login'], { 
              queryParams: { returnUrl: router.url }
            });
          }
          return throwError(() => error);
        })
      );
    }
  }
  
  // If no token or not an API request, proceed without modification
  return next(req);
};